import { Separator } from "@/components/ui/separator/separator";
import { LeadsAssignedToEmployeeChart } from "./_components/leads-assinged-employee-chart";
import { LeadsClosedChart } from "./_components/leads-closed-chart";

const LeadsActivityOfEmployees = () => {
  return (
    <div className="p-5">
      <LeadsAssignedToEmployeeChart />

      <Separator className="my-20" />

      <LeadsClosedChart />
    </div>
  );
};

export default LeadsActivityOfEmployees;
